export const getDisplayAlertName = ({alertName, config, i18n}) => {
  const {ALERT_NAME_PREFIX_I18N_OVERRIDES} = config.get('alerts')
  const parts = alertName.split(', ')
  const translatedParts = parts.map(part => {
    const i18nKey = ALERT_NAME_PREFIX_I18N_OVERRIDES?.[part]
    return i18nKey ? i18n.t(i18nKey) : part
  })
  return translatedParts.join(', ')
}
